import React, { useState } from 'react';

import { Button, Modal } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { useBlocker } from 'react-router-dom';

interface IPreventLocationChangeProps {
  allowedPaths?: string[];
  messageTitleKey: string;
  messageKey: string;
  confirmKey: string;
  cancelKey: string;
  onProceed?: any;
  shouldBlock?: boolean;
}

const PreventLocationChange = ({
  allowedPaths = [],
  messageTitleKey,
  messageKey,
  confirmKey,
  cancelKey,
  onProceed = null,
  shouldBlock = true
}: IPreventLocationChangeProps) => {
  const intl = useIntl();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [blockedLocation, setBlockedLocation] = useState<any>(null);

  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    const pathAllowed = allowedPaths.some((path) => nextLocation.pathname.includes(path));
    let navBlocked = false;

    if (!pathAllowed && currentLocation.pathname !== nextLocation.pathname && shouldBlock) {
      setBlockedLocation(nextLocation);
      setShowModal(true);
      navBlocked = true;
    }
    return navBlocked;
  });

  const handleProceed = () => {
    setShowModal(false);
    if (onProceed && blockedLocation) {
      onProceed(blockedLocation.pathname);
    }
    if (blocker.proceed) {
      blocker.proceed();
    }
    setBlockedLocation(null);
  };

  const handleCancel = () => {
    setShowModal(false);
    if (blocker.reset) {
      blocker.reset();
    }
    setBlockedLocation(null);
  };

  return (
    <Modal
      backdropClassName="overlaid"
      className="overlaid"
      show={showModal}
      onHide={handleCancel}
      backdrop="static"
      contentClassName="border-0 rounded-0"
      centered
      data-test="prevent-location-change-modal"
    >
      <Modal.Header>
        <Modal.Title>{intl.formatMessage({ id: messageTitleKey })}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{intl.formatMessage({ id: messageKey })}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button data-test="cancel-navigation" variant="link" onClick={handleCancel}>
          {intl.formatMessage({ id: cancelKey })}
        </Button>
        <Button data-test="confirm-navigation" variant="primary" onClick={handleProceed}>
          {intl.formatMessage({ id: confirmKey })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PreventLocationChange;
